var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYellow = function SvgYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 22",
    style: {
      enableBackground: "new 0 0 16 22"
    },
    fill: "#FFDE26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    className: "st0",
    d: "M12.94,22H3.06C1.37,22,0,20.63,0,18.94V3.06C0,1.37,1.37,0,3.06,0h9.89C14.63,0,16,1.37,16,3.06v15.89 C16,20.63,14.63,22,12.94,22z"
  }))));
};
export default SvgYellow;